import OnlinePaymentContactAddressModelBase from '../_generated/modelBases/online-payment-contact-address-model-base';

export default class OnlinePaymentContactAddressModel extends OnlinePaymentContactAddressModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
